export {newlineToBreak} from './lib/index.js'
